import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { installDropdown } from 'mewe/utils/dropdown-utils';

export default class MwAttachmentButton extends Component {
  element;

  @tracked dropdownOptions;

  constructor() {
    super(...arguments);
    installDropdown(this, 'dropdownOptions');
  }

  @action
  onInsert(element) {
    this.element = element;
  }

  @action
  openGiphyPicker() {
    this.args.openGiphyPicker(null, this.element);
  }

  @action
  browseFiles() {
    this.args.browseFiles();
  }

  @action
  browseVideos() {
    this.args.browseVideos();
  }

  @action
  openAudioRecording() {
    this.args.openAudioRecording();
  }

  @action
  openStickerPicker() {
    this.args.openStickerPicker(null, this.element);
  }

  setSticker(sticker) {
    this.args.setSticker(sticker);
  }
}
